module.exports = __webpack_public_path__ + "img/preview-7.0ac9c458.png";